import axios from 'axios';
import { Cotisation } from 'core/models';

export function getCotisations(year: number, search: object[]) {
    return axios.get<Cotisation[]>(`/cotisations/${year}/`, {
        params: {
            search: search && search.length ? JSON.stringify(search) : undefined,
        },
    });
}

export function exportCotisations(year: number, search: object[]) {
    return axios.get<Blob>(`/export_excel/cotisations/${year}/`, {
        params: {
            search: search && search.length ? JSON.stringify(search) : undefined,
        },
        responseType: 'blob',
    });
}
